import { Children, createContext, useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import classNames from "classnames";
import { motion } from "framer-motion";

export const ResizingContainerContext = createContext();

export function SharedResizingContainer({ children, style = {}, lessDrama }) {
  const childrenArray = Children.toArray(children);

  const currentScreen = children.find((child) => child.props.show)?.props
    .resizeKey;

  const [previousScreen, setPreviousScreen] = useState();
  const [nextScreen, setNextScreen] = useState();

  const [animating, setAnimating] = useState(false);
  const [currentHeight, setCurrentHeight] = useState();
  const [nextHeight, setNextHeight] = useState(false);

  const containerRef = useRef();

  useEffect(() => {
    if (!nextHeight) return;

    if (!previousScreen && !nextScreen && currentScreen) {
      setPreviousScreen(currentScreen);
    } else if (previousScreen) {
      const currentHeight = containerRef.current.getBoundingClientRect().height;

      if (currentHeight === nextHeight) return;

      setCurrentHeight(currentHeight);
      setNextScreen(currentScreen);
      setAnimating(true);
    }
  }, [nextHeight]);

  const heightAnimationComplete = (animation) => {
    if (animation.height === nextHeight) {
      setAnimating(false);
      setNextHeight(false);
    }
  };

  const screenToShow =
    (!nextScreen && !previousScreen && currentScreen) ||
    nextScreen ||
    previousScreen;

  const context = { animating, screenToShow, setNextHeight, lessDrama };

  if (!screenToShow) return null;

  return (
    <Container
      ref={containerRef}
      className={classNames({ animating })}
      style={{ ...style, height: animating ? currentHeight : "auto" }}
      animate={animating && { height: nextHeight }}
      onAnimationComplete={animating && heightAnimationComplete}
    >
      <ResizingContainerContext.Provider value={context}>
        {children}
      </ResizingContainerContext.Provider>
    </Container>
  );
}

const Container = styled(motion.div)`
  height: auto;
  display: flex;
  align-items: center;
  position: relative;
  &:not(.animating) {
    height: auto !important;
  }
  &.animating {
    overflow: hidden;
  }
`;
